import React, { useMemo, useState } from 'react';
import styles from './service-mini-card.module.scss';
import { IServicesCard } from 'shared/api/booking/interfaces/services-list.interface';
import { ModalWindow } from '../modal-window/modal-window';
import { observer } from 'mobx-react';
import { EditService } from 'features/edit-service/ui/edit-service';
import { UniversalImage } from '../universal-image/universal-image';
import { CircleImage } from '../circle-image/circle-image';
import { useAppMediaQuery } from 'shared/hooks';

export interface IServiceMiniCardProps {
  serviceInfo: IServicesCard;
  onDuplicate?: (service: IServicesCard) => void;
  onSuccess?: (message: string) => void;
}
const formatFio = (fio: string): string => {
  if (!fio) return '';

  const parts = fio.split(' ');
  if (parts.length < 3) return fio;

  const [lastName, firstName, patronymic] = parts;
  return `${lastName} ${firstName} ${patronymic.charAt(0)}.`;
};

export const ServiceMiniCard: React.FC<IServiceMiniCardProps> = observer(
  ({ serviceInfo, onDuplicate, onSuccess }) => {
    const [showServiceEdit, setShowServiceEdit] = useState<boolean>(false);
    const isMobileL = useAppMediaQuery('mobileL');

    const serviceClickHandler = () => {
      setShowServiceEdit(!showServiceEdit);
    };
    const formattedEmployees = useMemo(() => {
      return serviceInfo.employees.map((employee) => ({
        ...employee,
        formattedFio: formatFio(employee.fio),
      }));
    }, [serviceInfo.employees]);

    return (
      <div
        className={styles.service_card__container}
        onClick={serviceClickHandler}
      >
        <div>
          {showServiceEdit && (
            <ModalWindow onClickOutside={setShowServiceEdit}>
              <EditService
                serviceInfo={serviceInfo}
                onClose={() => setShowServiceEdit(false)}
                onDuplicate={onDuplicate}
                onSuccess={onSuccess}
              />
            </ModalWindow>
          )}
        </div>
        <div className={styles.card__info}>
          <div className={styles.info__head}>
            <div className={styles.head__img}>
              <UniversalImage imgSrc={serviceInfo.imgUrl} />
            </div>
            <div className={styles.head__stick}></div>
            <div className={styles.head__data}>
              <div className={styles.data__top}>
                <div className={styles.data__name}>{serviceInfo.name}</div>
                <div className={styles.data__duration}>
                  {serviceInfo.duration} мин.
                </div>
                <div className={styles.data__price}>{serviceInfo.price} р.</div>
              </div>
              <div className={styles.data__bottom}>
                <div className={styles.bottom__description}>
                  {serviceInfo.description}
                </div>
              </div>
            </div>
          </div>
          {formattedEmployees.length > 0 && !isMobileL ? (
            <div className={styles.info__employees}>
              {formattedEmployees.map((employee) => (
                <div key={employee.id} className={styles.employees__employee}>
                  <CircleImage imgSize={30} imgSrc={employee.imgUrl} />
                  <div className={styles.employee__fio}>
                    {employee.formattedFio}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);
